import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import IAWidget from './IAWidget'
import AvisoPagamentoPendente from './AvisoPagamentoPendente'
import AvisoTermosPendentes from './AvisoTermosPendentes'

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="min-h-screen bg-offwhite">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed}
        mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <div className={`${collapsed ? 'lg:ml-[68px]' : 'lg:ml-[260px]'} transition-[margin] duration-300 flex flex-col min-h-screen`}>
        <AvisoPagamentoPendente />
        <AvisoTermosPendentes />
        <Header onMenuToggle={() => setMobileOpen(true)} />
        <main className="p-4 sm:p-6 lg:p-8 flex-1"><Outlet /></main>
      </div>

      <IAWidget />
    </div>
  )
}
